import 'infinite-scroll/dist/infinite-scroll.pkgd'

let loadMore = jQuery('.load-more')

if (loadMore.length > 0) {

    let $holder = jQuery('.load-more__holder')

    let iSc = $holder.infiniteScroll({
        path: '.load-more__button',
        checkLastPage: true,
        append: '.load-more__holder .load-more-block',
        loadOnScroll: false,
        scrollThreshold: false,
        button: '.load-more',
        status: '.page-load-status',
        debug: false,
    })

    let updateResultsCount = () => {
        let $count = jQuery('.search-res__number[data-results-template]')

        if (!$count.length) {
            return
        }

        let from = parseInt($count.attr('data-results-from'), 10) || 1
        let total = parseInt($count.attr('data-results-total'), 10) || 0
        let shown = $holder.find('.load-more-block').length
        let to = Math.min(from + shown - 1, total)
        let template = $count.attr('data-results-template') || ''

        $count.text(
            template
                .replace('{from}', String(from))
                .replace('{to}', String(to))
                .replace('{total}', String(total))
        )
    }

    $holder.on('append.infiniteScroll', updateResultsCount)

}
